import { Box, ButtonGroup, Button } from '@mui/material';
import { PROJECT_SIZES, PROJECT_ASPECT_RATIOS, ProjectSize } from '../constants/project';

const ProjectSizeButtonGroup = ({ projectSize, onProjectSizeChange, projectAspectRatio, onProjectAspectRatioChange, showAspectRatio = true }:
  { projectSize: ProjectSize;
    onProjectSizeChange: (projectSize: ProjectSize) => void;
    projectAspectRatio?: string;
    onProjectAspectRatioChange?: (projectAspectRatio: string) => void;
    /** Show the aspect-ratio selector. Off in the single-project wizard, where
     *  projects are always square and grown via tile expansion instead. */
    showAspectRatio?: boolean }) => {
  const sizes = PROJECT_SIZES;
  const aspectRatios = PROJECT_ASPECT_RATIOS;

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', width: '500px', marginTop: '10px', marginLeft: '10px', }}>
      <ButtonGroup sx={{ width: '500px', marginBottom: '10px' }} variant="outlined" aria-label="size button group">
        {sizes.map((size) => {
          const buttonStyle = {
            display: 'flex',
            flex: 1,
            border: '1px solid transparent',
            backgroundColor: projectSize === size ? '#00d4ad' : 'white',
            color: projectSize === size ? 'white' : '#00d4ad',
            '&:focus': {
              outline: 'none',
              border: 'none',
            },
            '&:hover': {
              border: '1px solid #00d4ad',
            },
          };

          return (
            <Button key={size} sx={buttonStyle} onClick={() => onProjectSizeChange(size as ProjectSize)}>
              {size}
            </Button>
          );
        })}
      </ButtonGroup>
      {showAspectRatio && (
      <ButtonGroup sx={{ width: '500px' }} variant="outlined" aria-label="aspect ratio button group">
        {aspectRatios.map((ratio) => {
          const buttonStyle = {
            display: 'flex',
            flex: 1,
            border: '1px solid transparent',
            backgroundColor: projectAspectRatio === ratio ? '#00d4ad' : 'white',
            color: projectAspectRatio === ratio ? 'white' : '#00d4ad',
            '&:focus': {
              outline: 'none',
              border: 'none',
            },
            '&:hover': {
              border: '1px solid #00d4ad',
            },
          };

          return (
            <Button key={ratio} sx={buttonStyle} onClick={() => onProjectAspectRatioChange?.(ratio)}>
              {ratio}
            </Button>
          );
        })}
      </ButtonGroup>
      )}
    </Box>
  );
};

export default ProjectSizeButtonGroup;
